<template>
  <div :class="size">
    <div class="crowd-box-specialist" :class="getBgdColor()">
      <div class="crowd-box-photo">
        <router-link :to="{ name: 'show_profile', params: { id: specialist.id } }">
          <div class="avatar" style="width: 100%">
            <img v-if="specialist.photo.thumb.url" :src="$server_url + specialist.photo.thumb.url">
            <img v-else src="~assets/img/specialist.jpg">
          </div>
        </router-link>
      </div>
      <div class="crowd-box-text">
        <p><router-link :to="{ name: 'profiles'}" class="hire">{{ $t("specialist.header") }}</router-link></p>
        <p>
          <router-link :to="{ name: 'show_profile', params: { id: specialist.id } }" class="name">
            {{ specialist.full_name }}
          </router-link>
          <br/>
          <router-link v-if="specialist.profession" :to="{ name: 'profiles', query: { specialisation: specialist.profession.name }}" class="specialisation">
            {{ specialist.profession.name }}
          </router-link>
        </p>
        <p class="short-skills">{{ specialist.short_description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['specialist', 'size'],
  methods: {
    getBgdColor() {
      const x = Math.floor(Math.random() * 3);
      const colors = ['green-bgd', 'blue-bgd', 'red-bgd'];
      return colors[x];
    },
  },
};
</script>



// WEBPACK FOOTER //
// Specialist.vue?48abcb1f